import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import breakpoints from '../../Theme/breakpoints';

const SideBarContainer = styled.section`
  display: block;
`;

const SidebarAdUnit = styled.div`
  width: 100%;
  margin: 0 0 24px;

  @media (min-width: ${breakpoints.sm}px) {
    padding: 0 0 16px;
    border-bottom: 1px solid ${({ theme }) => theme.colors?.greyLight};
    margin: 0 0 16px;
  }

  @media (min-width: ${breakpoints.lg}px) {
    border-bottom: none;
  }
`;

const SidebarItem = styled.div`
  width: 100%;
  @media (min-width: ${breakpoints.sm}px) {
    width: calc(50% - (16px + 1px));
  }
  @media (min-width: ${breakpoints.lg}px) {
    width: 100%;
  }
`;

const MostReadSidebarItem = styled(SidebarItem)`
  margin: 0 0 24px;

  @media (min-width: ${breakpoints.sm}px) {
    border-right: 1px solid ${({ theme }) => theme.colors?.greyLight};
    padding: 0 16px 0 0;
    margin: 0;
  }
  @media (min-width: ${breakpoints.lg}px) {
    border-right: none;
    min-height: 632px;
  }
`;

const HighlightedJobsSidebarItem = styled(SidebarItem)`
  width: 100%;
  margin: 0;

  @media (min-width: ${breakpoints.sm}px) {
    padding: 0 0 0 16px;
  }
  @media (min-width: ${breakpoints.lg}px) {
    padding: 0;
    min-height: 263.5px;
  }
`;

const SideBar = ({
  adUnitItem,
  mostRead,
  highlightedJobs,
}) => (
  <SideBarContainer>
    {adUnitItem && (
    <SidebarAdUnit>
      {adUnitItem}
    </SidebarAdUnit>
    )}
    {mostRead && (
    <MostReadSidebarItem>
      {mostRead}
    </MostReadSidebarItem>
    )}
    {highlightedJobs && (
    <HighlightedJobsSidebarItem>
      {highlightedJobs}
    </HighlightedJobsSidebarItem>
    )}
  </SideBarContainer>
);
SideBar.propTypes = {
  adUnitItem: PropTypes.node,
  mostRead: PropTypes.node,
  highlightedJobs: PropTypes.node,
};

SideBar.defaultProps = {
  adUnitItem: undefined,
  mostRead: undefined,
  highlightedJobs: undefined,
};

export default SideBar;
